import type { ReactNode } from "react";
import { cn, toSafeReactNode } from "@/lib/utils";

export interface StatCardProps {
  label: string;
  value: string | number;
  trend?: string;
  icon?: ReactNode;
  glow?: boolean;
  className?: string;
}


export function StatCard({
  label,
  value,
  trend,
  icon,
  glow = false,
  className,
}: StatCardProps) {
  const safeValue = toSafeReactNode(value);
  const safeTrend = trend != null ? toSafeReactNode(trend) : null;
  return (
    <div
      className={cn(
        "rounded-lg border border-border bg-surface p-4 shadow-sm",
        glow && "shadow-glow-green",
        className
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-medium text-text-muted">{toSafeReactNode(label)}</span>
        {icon && (
          <span className="text-text-muted opacity-80" aria-hidden>
            {icon}
          </span>
        )}
      </div>
      <p className="mt-1 text-2xl font-semibold text-text">{safeValue}</p>
      {safeTrend != null && safeTrend !== "" && (
        <p className="mt-0.5 text-xs text-text-muted">{safeTrend}</p>
      )}
    </div>
  );
}
